import { Box, HStack, Image, Text } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { ItemModel } from "lib/api/model";
import usePathNavigate from "lib/hook/usePathNavigate";
import { digit } from "lib/utils/digit";

interface OrderItemProps {
    data: ItemModel;
}

const OrderItem = (props: OrderItemProps) => {
    const { pathNavigate } = usePathNavigate();
    const { data } = props;
    return (
        <HStack
            display={"flex"}
            mb="1rem"
            alignItems={"flex-start"}
            color={
                data.item_status === OrderStatus.CANCEL_ORDER ||
                data.item_status === OrderStatus.REJECT_ORDER
                    ? "#bdbdbd"
                    : "auto"
            }
            onClick={() => {
                pathNavigate(`/products/${data.item_id}`);
            }}
        >
            <Image
                src={data.image_path}
                w="4rem"
                h="4rem"
                border={"1px"}
                borderColor="#eeeeee"
                borderRadius={"md"}
            />
            <Box flex="1">
                <Text fontSize={"0.938rem"} fontWeight="semibold">
                    {`${data.category_name} / ${data.material_name} (${data.item_id})`}
                </Text>
                <Text
                    fontSize={"0.813rem"}
                    fontWeight="medium"
                    color={
                        data.item_status === OrderStatus.CANCEL_ORDER ||
                        data.item_status === OrderStatus.REJECT_ORDER
                            ? "#bdbdbd"
                            : "#757575"
                    }
                >
                    {data.service_name.map((v: string, index: number) =>
                        index > 0 ? ` · ${v}` : v
                    )}
                </Text>
                <HStack justify={"space-between"}>
                    <Text
                        fontSize={"0.938rem"}
                        fontWeight="bold"
                        textDecoration={
                            data.item_status === OrderStatus.CANCEL_ORDER ||
                            data.item_status === OrderStatus.REJECT_ORDER
                                ? "line-through"
                                : "none"
                        }
                    >
                        {`${digit(data.item_price)} 원`}
                    </Text>
                    {(data.item_status === OrderStatus.CANCEL_ORDER ||
                        data.item_status === OrderStatus.REJECT_ORDER) && (
                        <Text
                            fontSize={"0.938rem"}
                            fontWeight="bold"
                            color="#fc375f"
                        >
                            취소됨
                        </Text>
                    )}
                </HStack>
            </Box>
        </HStack>
    );
};

export default OrderItem;
